const kenectConfig = {
  src: 'https://review-carousel-resource.kenect.com/reviews_widget.min.js',
  id: 'KCidliBmPZKblZKU9p-jekM',
};

const selectors = {
  controlsContainer: '[data-carousel-controls]',
  carouselContainer: '[data-carousel-container]',
  kenectErrorContainer: '.kenect-errorWrapper',
  nextButton: '[data-carousel-next]',
  prevButton: '[data-carousel-prev]',
  kenectNext: '[data-glide-dir=">"]',
  kenectPrev: '[data-glide-dir="<"]',

  id: {
    kenectContainer: 'kenect-review-carousel',
    kenectGlide: 'kenect-reviews-carousel-glide',
  },
};

export { kenectConfig, selectors };
